import React from 'react';

import ProductHeader from '../../../product/components/product-header';
import HeaderCart from '../../../page/components/header-footer/header-cart';

import './sticky-tab.less';

export default ({ tabProps = {} }) => {
    const { HeaderComponent, ...restProps } = tabProps;
    return (
        <div className="sticky-tab-container">
            {HeaderComponent ? (
                <HeaderComponent {...restProps} />
            ) : (
                <ProductHeader className="sticky-tabs-nav" {...restProps} tabsListProps={{ dropdownOnMobile: true }} />
            )}
            <div className="cart-menu">
                <HeaderCart enableHeaderState={false} />
            </div>
        </div>
    );
};
